import React from "react";
import { motion } from "framer-motion";
import "./Roadmap.css";

const checkpoints = [
  { id: 1, title: "Earn your badge", note: "15% people got 3LPA offer here" },
  { id: 2, title: "Complete first project", note: "10% got promoted" },
  { id: 3, title: "Master advanced skills", note: "20% increased salary" },
  { id: 4, title: "Get certified", note: "5% landed dream job" },
];

const Roadmap = () => {
  const pathVariants = {
    hidden: { pathLength: 0, opacity: 0 },
    visible: {
      pathLength: 1,
      opacity: 1,
      transition: { duration: 2.5, ease: "easeInOut" },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.4 + 0.2,
        duration: 0.6,
        ease: "easeOut",
      },
    }),
  };

  const isMobile = window.innerWidth < 768;
  const pathData = isMobile
    ? "M 200 50 C 170 200, 230 400, 200 550 C 170 750, 230 950, 200 950"
    : "M 400 50 C 250 150, 550 250, 400 350 C 250 450, 550 550, 400 650 C 250 750, 550 850, 400 950";

  return (
    <div className="roadmap-container">
      <svg
        className="roadmap-svg"
        viewBox="0 0 400 1000"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <linearGradient id="pathGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#8b5cf6" />
            <stop offset="33%" stopColor="#ec4899" />
            <stop offset="66%" stopColor="#f59e0b" />
            <stop offset="100%" stopColor="#10b981" />
          </linearGradient>
        </defs>

        <motion.path
          d={pathData}
          fill="none"
          stroke="url(#pathGradient)"
          strokeWidth="6"
          strokeDasharray="15 15"
          strokeLinecap="round"
          strokeLinejoin="round"
          variants={pathVariants}
          initial="hidden"
          animate="visible"
        />
      </svg>

      <div className="checkpoints-wrapper">
        {checkpoints.map((checkpoint, index) => (
          <motion.div
            key={checkpoint.id}
            className={`checkpoint-card ${index % 2 === 0 ? "left" : "right"}`}
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            custom={index}
            whileHover={{ scale: 1.05, y: -5 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="checkpoint-number">{checkpoint.id}</div>
            <div className="checkpoint-content">
              <h3>{checkpoint.title}</h3>
              <p>{checkpoint.note}</p>
            </div>
            <div className="checkpoint-badge">
              <span className="badge-icon">✓</span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Roadmap;
